<template>
	<div>
		<v-form ref="form" @submit.prevent="filter()">
			<v-row dense align="center" class="mb-0">
				<!-- item-name -->
				<v-col lg="2" md="3" sm="4" cols="6">
					<v-autocomplete
						v-model="filterData.itemId"
						:label="$T('inputs.item-name')"
						:items="items.filter(c => c.type === type.sub)"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						hide-details
					/>
				</v-col>

				<!-- from-date -->
				<v-col lg="2" md="3" sm="4" cols="6">
					<bee-date-picker
						v-model="filterData.fromDate"
						:input-label="$T('inputs.from-date')"
						:input-props="{ dense: true, outlined: true, readonly: true }"
						hide-details
						menu-picker
					/>
				</v-col>

				<!-- to-date -->
				<v-col lg="2" md="3" sm="4" cols="6">
					<bee-date-picker
						v-model="filterData.toDate"
						:input-label="$T('inputs.to-date')"
						:input-props="{ dense: true, outlined: true, readonly: true }"
						hide-details
						menu-picker
					/>
				</v-col>

				<v-col cols="auto">
					<v-btn small type="submit" color="primary">
						<v-icon>$search</v-icon>
					</v-btn>
				</v-col>
				<v-spacer />
				<v-col>
					<v-menu
						v-model="showMenu"
						absolute
						offset-y
						style="max-width: auto"
						dense	
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-bind="attrs"
								v-on="on"
								dense
								height="30"
								class="px-1 black--text"
							>
								<div class="px-2 py-0 d-flex align-center">
									{{ $t('cardamom-in-the-detachment') }}

									<span class="text-h5 primary--text font-weight-bold mx-2">
										{{ 
											cardamomAmountInSorting.length 
												? $options.filters.numberFormat(fixNumber(cardamomAmountInSorting
													.map(c => c.remainingQty > 0 ? c.remainingQty : 0)
													.reduce((a, b) => a + b)))
												: '-' 
										}}
									</span> 
									<v-icon> mdi-chevron-down </v-icon>
								</div>
							</v-btn>
						</template>

						<bee-handy-table
							:headers="headersCardamom"
							:items="cardamomAmountInSorting"
							zebra
							dense
							:items-per-page="-1"
							hide-default-footer
						></bee-handy-table>
					</v-menu>
				</v-col>

				<v-spacer v-if="$route.query.itemId"  />
				<v-col v-if="$route.query.itemId" cols="auto">
					<v-btn
						class="px-2"
						color="bgColor"
						:to="{ name: 'inventory' }"
					>
						<v-icon size="20" class="me-1">$back</v-icon>
						{{$T('back')}}
					</v-btn>
				</v-col>
			</v-row>
		</v-form>

		<!-- table -->
		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			:items-per-page="20"
			fixed-header
			hide-default-footer
			pagination-on-scroll
			pagination-on-scroll-server-items
			:data-table-props="{ disableSort: true }"
			:server-items-length="serverItemsLength"
			shown-rows-text
			:loading="loading"
			:height="$vuetify.breakpoint.height - 170"
			zebra
			dense
			:disable-context-menu="!permissions.inventory.isReadWrite"
			:context-menu-items="permissions.inventory.isReadWrite ? contextMenuItems : []"
			@context-menu-edit="item => {
				if(item.item.type === 0) {
					$router.push({ name: 'material-journals', params: { id: item.item.materialsJournalId } })
				} else if(item.item.type === 1) {
					$router.push({ name: 'receiving-journals', params: { id: item.item.materialsJournalId } })
				} else if(item.item.type === 2) {
					$router.push({ name: 'production-orders', query: { id: item.item.materialsJournalId } })
				} else if(item.item.type === 3) {
					$router.push({ name: 'order-results', query: { id: item.item.materialsJournalId } })	
				} else if(item.item.type === 4) {
					$router.push({ name: 'delivery-journals', params: { id: item.item.materialsJournalId } })
				}
			}"
			@pagination-on-scroll:reach-last-row="filter"
		></bee-handy-table>
		<!-- footer for total statistics -->
		<v-footer app inset elevation="10" class="justify-space-around grey lighten-2">
			<div>
				{{$T('total-in')}}
				<span class="ms-2 font-weight-bold">
					{{ (totalIn ? ($options.filters.numberFormat(fixNumber(+totalIn))) : 0) + ' qq' }}
				</span>
			</div>
			
			<div>
				{{$T('total-out')}}
				<span class="ms-2 font-weight-bold">
					{{ (totalOut ? ($options.filters.numberFormat(fixNumber(+totalOut))) : 0) + ' qq' }}
				</span>
			</div>

			<div>
				{{$T('remaining-quantity')}}:
				<span class="ms-2 font-weight-bold">
					{{
						(remainingTotal ? ($options.filters.numberFormat(fixNumber(+remainingTotal))) : 0) + ' qq'
					}}
				</span>
			</div>
		</v-footer>
	</div>

	<!--
0 -->

	<!--	
			}" -->
</template>

<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import { type, cardamomStatus } from '@/helpers/enums';
import { fixNumber } from '@/helpers/functions'

export default {
	name: 'ItemsStatement',

	data() {
		return {
			loading: false,
			type,

			filterData: {
				itemId: null,
				fromDate: moment().startOf('month').format('YYYY-MM-DD'),
				toDate: moment().endOf('month').format('YYYY-MM-DD'),
			},

			serverItemsLength: 0,
			cardamomStatus,
			showMenu: false,
			remainingTotal: null,
			totalIn: null,
			totalOut: null
		}
	},

	computed: {
		...mapState({
			items: state => state.items.items,
			cardamomAmountInSorting: state => state.transactions.cardammanAmount,
			owners: state => state.configs.configsTrees.owners,
			permissions: state => state.auth.self.permissions
		}),

		...mapGetters({
			getAccountById: 'accounts/getAccountById',
			getItemById: 'items/getItemById',
		}),

		headers() {
			return [
				{
					text: this.$T('headers.item'),
					name: 'itemId',
					value: 'itemId',
					setValueExpr: val => this.getItemById(val)?.name
				},
				{
					text: this.$T('headers.in'),
					name: 'in',
					value: 'in',
					type: 'number-format'
				},
				{
					text: this.$T('headers.out'),
					name: 'out',
					value: 'out',
					type: 'number-format'
				},
				{
					text: this.$T('headers.owner'),
					name: 'owner',
					value: 'owner',
					setValueExpr: val => this.getAccountById(val)?.name ?? 'Ugarit'
				},
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					width: 120,
				},
				{
					text: this.$T('headers.notes'),
					name: 'notes',
					value: 'notes'
				},
			]
		},

		headersCardamom() {
			return [
				{ 
					text: 'Owner', 
					name: 'ownerId', 
					value: 'ownerId', 
					noNotAvailableText: true,
					setValueExpr: val => val !== null ? this.owners.find(c => c.id === val)?.name : 'Ugarit'
				}, 
				{ 
					text: 'Quantity',
					name: 'remainingQty', 
					value: 'remainingQty', 
					setValueExpr: val => val + ' qq',
					type: 'number-format',
					columnClass: 'font-weight-bold' 
				}
			]
		},

		contextMenuItems () {
			return [
				{
					title: this.$T('view').toUpperCase(),
					event: 'edit',
					class: 'warning-color--text',
					icon: '$edit',
					iconColor: 'warning-color',
					iconClass: 'me-1'
				}
			]
		} 
	},

	methods: {
		fixNumber,

		filter(newScrollOption) {
			let page = 1;
			let itemsPerPage = 20;
			if (newScrollOption) {
				page = newScrollOption.page;
				itemsPerPage = newScrollOption.itemsPerPage;
			} else if (this.$refs.table) {
				this.$refs.table.resetShownRows();
			}
			this.loading = true;
			this.$store.dispatch('transactions/fetchAll', {
				itemId: this.filterData.itemId,
				fromDate: this.filterData.fromDate,
				toDate: this.filterData.toDate,
				page,
				perPage: itemsPerPage
			}).then(({ data, total, headers }) => {
				this.serverItemsLength = total;
				this.$refs.table.addScrollItems(data);
				this.remainingTotal = headers['x-remaining-quantity']
				this.totalIn = headers['x-sum-input']
				this.totalOut = headers['x-sum-output']
			}).finally(() => {
				this.loading = false;
			})
		}
	},

	created() {
		if (this.$route.query.itemId) {
			this.filterData.itemId = this.$route.query.itemId;
			this.filter();
		}
		this.$store.dispatch('transactions/fetchCardammon', { 
			cardammomStatus: cardamomStatus.inSorting, 
			Withdetails: true
		})
	}
}
</script>

<style>

</style>